import React from 'react';
import { ItemDetail } from '../menu-modal.styles';
import * as S from './item-description.styles';
import Calories from '../calories/calories.component';

const ItemDescription = ({
  title,
  shortDescription,
  longDescription,
  itemId,
  catalog,
  calories,
}) => {
  return (
    <ItemDetail>
      <S.ItemName
        component="h2"
        data-testid="CatalogModal.ItemDetail.Title"
        id={`dialog-title-${itemId}`}
      >
        {title}
      </S.ItemName>
      <Calories
        catalogExtendedAttributes={catalog.extendedAttributes}
        calories={calories}
        mainItem
      />
      {shortDescription && (
        <S.ItemDescription data-testid="CatalogModal.ItemDetail.ShortDescription">
          {shortDescription}
        </S.ItemDescription>
      )}
      {longDescription && (
        <S.ItemDescription data-testid="CatalogModal.ItemDetail.LongDescription">
          {longDescription}
        </S.ItemDescription>
      )}
    </ItemDetail>
  );
};

export default ItemDescription;
